module.exports = __webpack_public_path__ + "img/allyMapLocation.6a2aee4c.webp";